import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Steps} from "primereact/steps";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {SelectButton} from "primereact/selectbutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import "../../css/StepsDemo.css";
import {Tag} from "primereact/tag";
import {InputNumber} from "primereact/inputnumber";
import {InputSwitch} from "primereact/inputswitch";


const AddFlavor = props => {
    // Definitions
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [flavorName, setFlavorName] = useState(null);
    const [ramSize, setRamSize] = useState(null);
    const [diskSize, setDiskSize] = useState(null);
    const [cpuCount, setCpuCount] = useState(null);
    const [gpuCount, setGpuCount] = useState(null);

    useEffect(() => {
    }, []);

    // Messages
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const showInfo = (message, detail) => {
        toast.current.show({severity: 'info', summary: message, detail: detail, life: 3000});
    }

    // Controllers
    const textController = (func, value) => {
        var re = /^[a-zA-Z0-9 _ıİçÇşŞöÖüÜğĞ.]*$/;
        if (re.test(value) || value.length === 0) {
            func(value);
        } else {
            showError("Yalnızca Harf, Sayı ve Alt Çizgi Kullanılmalıdır");
        }
    }

    const closeFlavorDialog = () => {
        props.setAddFlavorDialog(false);
    }

    const createFlavor = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (!flavorName || flavorName.length < 3) {
                showError("Şablon Adı En Az 3 Karakterli Olmalıdır!");
                return;
            }
            if (!ramSize && ramSize >= 512) {
                showError("Ram boyutu En az 512 MB Olacak Şekilde Belirtilmelidir!");
                return;
            }
            if (!diskSize && diskSize >= 1) {
                showError("Disk Boyutu En az 1 GB Olacak şekilde Belirtilmelidir!");
                return;
            }

            const data = {
                "flavor_name": flavorName,
                "ram_size": ramSize,
                "disk_size": diskSize,
                "cpu": cpuCount,
                "gpu": gpuCount,
            }
            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            showInfo("Şablon Oluşturluyor", "Şablon");
            fetch("/api/cloud-flavor/", {headers, method: "POST", body: body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                            setTimeout(closeFlavorDialog, 3000);
                            setTimeout(props.getFlavors, 3000);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }
    }

    const getTextInput = (text_label, value, setValue) => {
        return (
            <div className="p-field">
                <label htmlFor="text_input">{text_label}</label>
                <InputText id="text_input" value={value} onChange={(e) => textController(setValue, e.target.value)}/>
            </div>
        );
    }

    const getNumberInput = (text_label, value, setValue) => {
        return (
            <div className="p-field">
                <label htmlFor="number_input">{text_label}</label>
                <InputNumber inputId="number_input" value={value} onValueChange={(e) => setValue(e.value)}
                             mode="decimal" useGrouping={false}/>
            </div>
        );
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{wordBreak: 'break-all'}}>
                    {getTextInput("Şablon Adı", flavorName, setFlavorName)}
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{wordBreak: 'break-all'}}>
                    {getNumberInput("Ram Boyutu (MB)", ramSize, setRamSize)}
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{wordBreak: 'break-all'}}>
                    {getNumberInput("CPU (Adet)", cpuCount, setCpuCount)}
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{wordBreak: 'break-all'}}>
                    {getNumberInput("GPU (Adet)", gpuCount, setGpuCount)}
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{wordBreak: 'break-all'}}>
                    {getNumberInput("Disk Boyutu (GB)", diskSize, setDiskSize)}
                </div>
                <div className="p-col-12" style={{marginBottom: "15px"}}>
                    <div className="p-grid">
                        <div className="p-col-12 p-sm-12 p-md-7 p-lg-8 p-xl-8"></div>
                        <div className="p-col-12 p-sm-12 p-md-5 p-lg-4 p-xl-4" align="right">
                            <Button icon="pi pi-save"
                                    label="Şablon Oluştur"
                                    className="p-button-text p-button-raised p-button-secondary"
                                    onClick={(e) => {
                                        createFlavor();
                                    }}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddFlavor);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/AddFlavor.jsx